goog.provide("shadow.js.shim.module$$embedpdf$plugin_interaction");
goog.provide("module$shadow_js_shim_module$$embedpdf$plugin_interaction");
shadow.js.shim.module$$embedpdf$plugin_interaction = shadow.js.nativeProvides["@embedpdf/plugin-interaction"] = shadow$bridge("@embedpdf/plugin-interaction");
module$shadow_js_shim_module$$embedpdf$plugin_interaction.default = shadow.js.shim.module$$embedpdf$plugin_interaction;
